import api from './api.service';

export default {
    getNoteTypes(companyId) {
        return api.get(`/company/note-types?companyId=${companyId}`);
    },
    createNoteType(data) {
        return api.post('/company/note-types', data);
    },
    updateNoteType(id, data) {
        return api.put(`/company/note-types/${id}`, data);
    },
    deleteNoteType(id, companyId) {
        return api.delete(`/company/note-types/${id}?companyId=${companyId}`);
    },
    getNotePriorities(companyId) {
        return api.get(`/company/note-priorities?companyId=${companyId}`);
    },
    createNotePriority(data) {
        return api.post('/company/note-priorities', data);
    },
    updateNotePriority(id, data) {
        return api.put(`/company/note-priorities/${id}`, data);
    },
    deleteNotePriority(id, companyId) {
        return api.delete(`/company/note-priorities/${id}?companyId=${companyId}`);
    }
};
